import { ExternalSync, ExternalSyncError, ExternalSyncStatus } from '@common/entities';

const unknownSyncError: ExternalSyncError = {
  operation: 'external sync',
  message: 'Unknown error syncing data',
};

/**
 * Returns errors that should be shown for an external synchronization result.
 * A pending marker remains incomplete, but local validation errors already
 * explain why no external synchronization result is available yet.
 */
export function getDisplayableExternalSyncErrors(
  externalSync: ExternalSync | undefined,
  errorCount: number | null | undefined,
): ExternalSyncError[] {
  if (!externalSync || externalSync.status === ExternalSyncStatus.Succeeded) {
    return [];
  }

  const isPendingWithLocalValidationErrors =
    externalSync.status === undefined && !externalSync.errors?.length && (errorCount ?? 0) > 0;

  if (isPendingWithLocalValidationErrors) {
    return [];
  }

  return externalSync.errors ?? [unknownSyncError];
}
